/* eslint-disable */
/**
 * DO NOT MODIFY IT BY HAND. Run `yarn rum-events-format:sync` instead.
 */
export {};
//# sourceMappingURL=telemetryEvent.types.js.map